import React, { useState } from 'react';
import { FaMicrophoneSlash } from 'react-icons/fa6';
import { getCurrentSession } from '../siphook/sipService';
import * as S from '../sipstyles/SipClient.style';

const MuteComponent = () => {
  const [isMuted, setIsMuted] = useState(false); // 음소거 상태

  // 음소거 토글
  const toggleMute = () => {
    const session = getCurrentSession(); // 현재 WebRTC 세션 가져오기
    if (session) {
      const audioTracks = session.connection
        .getSenders()
        .filter((sender) => sender.track && sender.track.kind === 'audio')
        .map((sender) => sender.track);
      audioTracks.forEach((track) => {
        if (track) {
          track.enabled = !track.enabled;
        }
      });
      setIsMuted((prev) => !prev);
    }
  };

  return (
    <S.MuteButton onClick={toggleMute} isMuted={isMuted}>
      <FaMicrophoneSlash />
    </S.MuteButton>
  );
};

export default MuteComponent;
